/**
 * Componente que renderiza una imagen optimizada con soporte responsive utilizando el elemento <picture>.
 * Genera automáticamente versiones de imagen para diferentes resoluciones a partir de una URL base.
 *
 * @param {Object} props
 * @param {string} props.url - URL original de la imagen.
 * @param {string} props.title - Texto alternativo para accesibilidad y SEO.
 *
 * Este componente está diseñado para trabajar con imágenes que siguen la convención de nombres:
 *  - imagen-300x169.jpg
 *  - imagen-768x432.jpg
 *  - imagen-1024x576.jpg
 *  - imagen.jpg (original)
 */
export default function ImageHTML({ url, title }) {
  // Definición de dimensiones comunes
  const width = 768;
  const height = 432;
  // Separación de la extensión y base de la URL para reconstruir rutas responsivas
  const urlParts = url.split('.');
  const extension = urlParts.pop();
  const baseUrl = urlParts.join('.');
  // Construcción de versiones para distintas resoluciones
  const url300x169 = `${baseUrl}-300x169.${extension}`; // móvil pequeño
  const url768x432 = `${baseUrl}-${width}x${height}.${extension}`; // tablet/media
  const url1024x576 = `${baseUrl}-1024x576.${extension}`; // desktop
  const urlFull = `${baseUrl}.${extension}`; // original

  return (
    <picture>
      {/* Fuente para pantallas pequeñas */}
      <source
        srcSet={url300x169}
        media="(max-width: 480px)"
      />
      {/* Fuente para pantallas medianas como tablets */}
      <source
        srcSet={url768x432}
        media="(max-width: 1024px)"
      />
      {/* Fuente para pantallas grandes */}
      <source
        srcSet={urlFull}
        media="(min-width: 1025px)"
      />

      {/* Imagen de fallback con múltiples resoluciones para navegadores que no interpretan <source> */}
      <img
        loading="lazy"
        decoding="async"
        width="300"
        height="169"
        src={url300x169}
        alt={title}
        srcSet={`${url300x169} 300w, ${url1024x576} 1024w, ${url768x432} 768w, ${urlFull} 1200w`}
        sizes="(max-width: 480px) 100vw, (max-width: 1024px) 100vw, 1200px"
        className='amx-notas-homes-img attachment-medium size-medium wp-post-image'
      />
    </picture>
  );
}
